import React, { useEffect, useState } from 'react';
import 'waypoints/lib/noframework.waypoints';
import PropTypes from 'prop-types';

const Jumplinks = ({ placeholder }) => {
  const [sections, setSections] = useState();
  const [selectedSection, setSelectedSection] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    const sectionsInDOM = document.querySelectorAll('[data-anchor]');
    const sections = Array.from(sectionsInDOM).map(section => {
      if (section.dataset.anchor) {
        section.id = section.dataset.anchor.replace(/\s/g, '');
      }
      return section;
    });
    if (sections.length)
      setSections(sections.filter(x => x.dataset.anchor !== ''));
  }, []);

  useEffect(() => {
    const sectionsInDOM = [...document.querySelectorAll('[data-anchor]')];
    sectionsInDOM.forEach((section, i) => {
      // eslint-disable-next-line no-undef
      new Waypoint({
        element: section,
        offset: 94,
        handler: direction => {
          if (direction === 'down') {
            setSelectedSection(i);
          } else {
            setSelectedSection(i - 1);
          }
          window.history.pushState(
            '',
            '',
            `${window.location.pathname}#${section.id.replace(/\s/g, '')}`
          );
        }
      });
    });
  }, []);

  useEffect(() => {
    const url = window.location.href;
    const anchor = url.split('#')[1];
    const section = document.querySelector(`#${anchor}`);

    if (section) {
      window.scrollBy(0, section.getBoundingClientRect().top);
    }
  }, []);

  const handleActiveTab = sectionLabel => {
    const currentSection = document.querySelector(
      `#${sectionLabel.replace(/\s/g, '')}`
    );
    if (sectionLabel) {
      // add id to querystring
      window.history.pushState(
        '',
        '',
        `${window.location.pathname}#${sectionLabel.replace(/\s/g, '')}`
      );
      setActiveTab(sectionLabel);
      if (currentSection) {
        window.scrollBy(0, currentSection.getBoundingClientRect().top - 94);
      }
    }
    setIsOpen(false);
  };

  const handleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const jumpLinksList = sections?.map((section, index) => {
    let sectionLink, sectionLabel;
    if (section.dataset.anchor) {
      sectionLabel = section.dataset.anchor;
      sectionLink = `#${section.dataset.anchor.replace(/\s/g, '')}`;
    }

    return (
      <li
        className="jumplinks__link"
        key={index}
        aria-selected={selectedSection === index}
        onClick={() => handleActiveTab(sectionLabel)}
      >
        {sectionLabel}
      </li>
    );
  });

  return (
    <div className="jumplinks container">
      <div className="jumplinks__links-container">
        <div className="jumplinks__inner">{sections ? jumpLinksList : ''}</div>
        <div className="jumplinks__dropdown">
          <div
            className="jumplinks__dropdown-selected"
            onClick={() => handleDropdown()}
          >
            <span>{placeholder}</span> {activeTab ? activeTab : 'Select'}
          </div>
          <ul className="jumplinks__dropdown-list" data-open={isOpen}>
            {sections ? jumpLinksList : ''}
          </ul>
        </div>
      </div>
    </div>
  );
};

Jumplinks.propTypes = {
  placeholder: PropTypes.string.isRequired
};

export default Jumplinks;
